import { isEmployedStatus } from "@/declare/enums/user-status";
import { USER_TYPE } from "@/declare/enums/user-type";
import localStore from "@/store/local-store";
import { Navigate, Outlet } from "react-router-dom";

// 判断是否是员工
const useEmpAuth = () => {
    const user = localStore.getUser();
    if (user?.libAdmin || isEmployedStatus(user?.userStatus)) {
        return true;
    }
    return false;
};

// 判断是否登录
const useLoginAuth = () => {
    const userId = localStore.userId;
    return !!userId;
}

// 权限路由包装
const RequireAuth = () => {
    const authed = useLoginAuth();
    const empAuthed = useEmpAuth();

    if (!authed) {
        // 未登录直接跳转登录页
        return <Navigate to="/login" replace />;
    } else if (!empAuthed) {
        return <Navigate to="/recruit/about" replace />;
    }

    // 已登录，放行
    return <Outlet />;
};

export default RequireAuth;
